import { format } from 'date-fns';
import flagType from '../shared/flag-type';
import helper from '../shared/helper';
import { TOGGLE_SNACKBAR } from './../events';

function data() {
	return {
		languages: {
			es: {
				id: 'es',
				name: 'Español',
			},
			en: {
				id: 'en',
				name: 'English',
			},
		},
		actionsToHelp: [],
		limit: 20,
		loadingExcel: false,
		snackbar: {
			text: '',
			isVisible: false,
			color: 'primary',
			timeout: 0,
		},
		table: {
			params: {
				currency: null,
				search: null,
				limit: 20,
				page: 1,
				sortField: 'created_at',
				sortDirection: 'desc',
			},
			lastPage: 1,
			rows: [],
		},
		inventoriesType: [
			{
				id: 1,
				name: 'Parcial',
				msg: null,
			},
			{
				id: 2,
				name: 'Completo',
				msg: {
					title: 'NOTA IMPORTANTE',
					text: 'Los productos que no aparezcan en este inventario serán actualizados con stock = 0 al momento de hacer el cierre.',
				},
			},
		],
		documentMessage: '',
		maxDocument: 0,
		minDocument: 0,
		personTypes: [],
		personType: {},
		personValidations: null,
	};
}

function calculateLimit() {
	const footerHeight = 29;
	const headerHeight = 62;
	const rowHeight = 30;
	const usedHeight = footerHeight + headerHeight;
	const availableHeight = document.body.clientHeight - usedHeight;
	const limit = Math.ceil(availableHeight / rowHeight);
	if (limit > 20) {
		this.limit = limit;
	}
}

function setProductPrice(product, products) {
	const newProduct = { ...product };
	const updateProducts = [...products];
	const selectedPriceList = newProduct.priceList[newProduct.selectedPriceListId];
	newProduct.price = this.getProductPrice(newProduct.quantity, selectedPriceList);
	if (!newProduct.price) {
		newProduct.price = product.price;
	}
	updateProducts.forEach((e) => {
		if (e.id === newProduct.id) {
			e.price = newProduct.price;
		}
		return e;
	});
	return updateProducts;
}

function getProductPrice(quantity, priceList) {
	if (priceList.ranges.length > 0) {
		const newPrice = priceList.ranges.filter(el => el.from <= quantity && el.to >= quantity);
		return newPrice.length > 0 ? newPrice[0].price : priceList.price;
	}
	return priceList.price;
}

function newAmountsCalculate(products, flagIgv) {
	const taxValue = 18 / 100;
	let total = 0;
	let tax = 0;
	let subtotal = products.reduce((acum, currentProduct) =>
		acum + (currentProduct.priceList[currentProduct.selectedPriceListId].price
			* currentProduct.quantity), 0);
	const discount = products.reduce((acum, currentProduct) =>
		acum + (currentProduct.discount * currentProduct.quantity), 0) || 0;
	subtotal -= discount;
	if (flagIgv === 0) {
		tax = this.roundInNumber(subtotal * taxValue);
		total = this.roundInNumber(subtotal + tax);
	} else {
		total = this.roundInNumber(subtotal);
		subtotal = this.roundInNumber(total / (1 + taxValue));
		tax = this.roundInNumber(total - subtotal);
	}
	const amounts = {
		subtotal,
		tax,
		discount,
		total,
	};
	return amounts;
}

function amountsCalculate(rows, priceListId, flagIgv, pageCode, globalDiscount) {
	const taxValue = 18 / 100;
	let total = 0;
	let tax = 0;
	const newRows = rows.map((row) => {
		const newRow = { ...row };
		if (priceListId && pageCode !== 'TNV') {
			if (row.priceList && row.priceList[priceListId]) {
				newRow.priceToSubtotal = row.priceList[priceListId].price;
				row.priceList[priceListId].ranges.forEach((range) => {
					if (row.quantity &&
						(row.quantity > (range.from - 1) && row.quantity < (range.to + 1))) {
						newRow.priceToSubtotal = range.price;
					}
				});
			} else if (row.product && row.product.priceList && row.product.priceList[priceListId]) {
				if (row.product.priceList[priceListId].quantity
					&& row.quantity >= row.product.priceList[priceListId].quantity) {
					newRow.priceToSubtotal = row.product.priceList[priceListId].wholeSalePrice;
				} else {
					newRow.priceToSubtotal = row.product.priceList[priceListId].price;
				}
			} else {
				newRow.priceToSubtotal = 0;
				newRow.discount = row.discount ? row.discount : 0;
			}
		} else {
			newRow.priceToSubtotal = row.price;
		}
		return newRow;
	});
	let subtotal = newRows.reduce((acum, currentRow) =>
		acum + (currentRow.priceToSubtotal * currentRow.quantity), 0);
	if (flagIgv === 0) {
		tax = this.roundInNumber(subtotal * taxValue);
		total = this.roundInNumber(subtotal + tax);
	} else {
		total = this.roundInNumber(subtotal);
		subtotal = this.roundInNumber(total / (1 + taxValue));
		tax = this.roundInNumber(total - subtotal);
	}
	const discount = newRows.reduce((acum, currentRow) =>
		acum + (currentRow.discount * currentRow.quantity), 0);
	if (pageCode === 'TNV') {
		total = globalDiscount ? this.roundInNumber(((subtotal + tax) - globalDiscount)) :
			this.roundInNumber(subtotal + tax);
	} else {
		total = discount ? this.roundInNumber(((subtotal + tax) - discount)) :
			this.roundInNumber(subtotal + tax);
	}
	const amounts = {
		newRows,
		subtotal,
		tax,
		discount,
		total,
	};
	return amounts;
}

function brandsList() {
	return this.$httpProducts.get('brands');
}

function customersList(params) {
	return this.$httpSales.get('customers', { params });
}

function customerSelections(value) {
	return this.$httpSales.get('customers', { params: { search: value } });
}

function globalEmployees() {
	return this.$httpSales.get('employees');
}

function goTo(name, options) {
	switch (name) {
	case 'new-sale':
		window.open('/new-sale', '_self');
		break;
	case 'new-quotation':
		window.open('/new-quotation', '_self');
		break;
	default:
		this.$router.push({ name, ...options });
		break;
	}
}

function warehousesList(params) {
	return this.$httpProducts.get('warehouses', { params });
}

function expensesList(params, host = '$httpSales', url = 'expenses') {
	return this[host].get(url, { params });
}

function typeExpensesList() {
	return this.$httpSales.get('type-expenses');
}

function subsidiariesList(params) {
	return this.$httpSales.get('subsidiaries', { params });
}

function massiveUploadList(params) {
	return this.$httpProducts.get('massive-upload/list', { params });
}
function massiveUploadRollback(id) {
	return this.$httpProducts.post(`massive-upload/${id}/rollback`);
}

function productsSelections(value) {
	const params = { search: value, noServices: 1 };
	return this.$httpProducts.get('products', { params });
}

function employeeSelections(value) {
	return this.$httpProduction.get('employees', { params: { search: value } });
}

function getExchangeRate() {
	return this.$httpSales.get('exchange-rate');
}

function exchangeByDate() {
	const date = this.$today;
	return this.$httpSales.get(`exchange-rates/${date}`);
}

async function exportTable(columns, rows, name) {
	const code = 'xlsx';
	const model = {
		code,
		columns,
		rows,
	};
	if (rows.length > 0) {
		try {
			const response = await this.$httpSales.post('reports', model, { responseType: 'blob' });
			const blob = helper.generateBlob(response.data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
			helper.showDownloadDialog(blob, name, code);
		} catch (err) {
			this.showNotification('Ocurrió un error en el servidor al intentar exportar la data', 'error');
		}
	} else {
		this.showNotification('Debe seleccionar una o más filas para exportar.', 'warning');
	}
}

function categoriesList() {
	return this.$httpProducts.get('categories');
}

function getCheckSeries(params) {
	return this.$httpSales('check-series', { params });
}

function getChecks(params) {
	return this.$httpSales.get('check', { params });
}

function getAccountType() {
	return this.$httpSales.get('bank-account-type');
}

function listOfUnits(params) {
	return this.$httpProducts.get('units', { params });
}

function listPricingPromise(params) {
	return this.$httpSales.get('sal-price-lists', { params });
}

function getPaymentsMethods() {
	return this.$httpSales.get('payments-methods');
}

function getTypePayments(type) {
	if (type) {
		const params = { flagType: type === 'sales' ? flagType.Sales : flagType.Purchases };
		return this.$httpSales.get('type-payments', { params });
	}
	return this.$httpSales.get('type-payments');
}

function getTypeDocuments(type) {
	if (type) {
		const params = { flagType: type === 'sales' ? flagType.Sales : flagType.Purchases };
		return this.$httpSales.get('type-documents', { params });
	}
	return this.$httpSales.get('type-documents');
}

function getBankAccount(id, params) {
	const url = id ? `bank-account/${id}` : 'bank-account';
	return this.$httpSales.get(url, { params });
}

function getBanks() {
	return this.$httpSales.get('banks');
}

function roundInNumber(value) {
	return Math.round(value * 100) / 100;
}

function showNotification(text, color = 'green', timeout = 5000) {
	this.$bus.$emit(TOGGLE_SNACKBAR, { color, text, timeout });
}

async function onEmitDocumentWithFormat(code, originName, params, isGenericReport = false, module = 'ventas', extension = 'xlsx', onlyName) {
	this.loadingExcel = true;
	const now = format(new Date(), 'YYYY_MM_DD_HH_mm_ss');
	const { name, lastname } = this.$userInfo;
	const documentData = {
		filename: onlyName ? originName : `${originName}${now}`,
		extension,
		comment: `${originName} generado por ${name} ${lastname}`,
		module: isGenericReport ? module : undefined,
		params,
	};
	const url = `${isGenericReport ? 'generic' : 'documents'}/${code}`;
	await this.$httpReports.post(url, documentData);
	this.showExcelGenerateMessage();
}

async function onEmitExcel(code, originName, params, isGenericReport = false, module = 'ventas', isDate = true) {
	this.loadingExcel = true;
	const now = format(new Date(), 'YYYY_MM_DD_HH_mm_ss');
	const { name, lastname } = this.$userInfo;
	const documentData = {
		filename: `${originName}${isDate ? now : ''}`,
		extension: 'xlsx',
		comment: `${originName} generado por ${name} ${lastname}`,
		module: isGenericReport ? module : undefined,
		params,
	};
	const url = `${isGenericReport ? 'generic' : 'documents'}/${code}`;
	await this.$httpReports.post(url, documentData);
	this.showExcelGenerateMessage();
}

async function onAmortizationList(originName, params) {
	const now = format(new Date(), 'YYYY_MM_HH_mm_ss');
	const { name, lastname } = this.$userInfo;
	const documentData = {
		filename: `${originName}${now}`,
		extension: 'pdf',
		comment: `${originName} generado por ${name} ${lastname}`,
		params,
	};
	await this.$httpReports.post('documents/list-document-account-status-pdf', documentData);
	const hrefTag = '<a href="/documents" style="color:white; text-decoration:underline; font-weight:bold;">Documentos</a>';
	const msg = `El reporte está siendo generado, puede revisar su estado en la sección de ${hrefTag}`;
	this.showNotification(msg, 'green', 20000);
}

async function onPayableList(originName, params) {
	const now = format(new Date(), 'YYYY_MM_HH_mm_ss');
	const { name, lastname } = this.$userInfo;
	const documentData = {
		filename: `${originName}${now}`,
		extension: 'pdf',
		comment: `${originName} generado por ${name} ${lastname}`,
		params,
	};
	await this.$httpReports.post('documents/list-document-account-status-pdf', documentData);
	const hrefTag = '<a href="/documents" style="color:white; text-decoration:underline; font-weight:bold;">Documentos</a>';
	const msg = `El reporte está siendo generado, puede revisar su estado en la sección de ${hrefTag}`;
	this.showNotification(msg, 'green', 20000);
}

async function onProductList(originName, params) {
	const now = format(new Date(), 'YYYY_MM_HH_mm_ss');
	const { name, lastname } = this.$userInfo;
	const documentData = {
		filename: `${originName}${now}`,
		extension: 'pdf',
		comment: `${originName} generado por ${name} ${lastname}`,
		params,
	};
	await this.$httpReports.post('documents/list-products-pdf', documentData);
	const hrefTag = '<a href="/documents" style="color:white; text-decoration:underline; font-weight:bold;">Documentos</a>';
	const msg = `El reporte de productos está siendo generado, puede revisar su estado en la sección de ${hrefTag}`;
	this.showNotification(msg, 'green', 20000);
}

async function onReportSale(params) {
	const now = format(new Date(), 'YYYY_MM_DD_HH_mm_ss');
	const { name, lastname } = this.$userInfo;
	const documentData = {
		filename: `Reporte_Lista_de_ventas_pdf ${now}`,
		extension: 'pdf',
		comment: `Reporte_Lista_de_ventas_pdf generado por ${name} ${lastname}`,
		params,
	};
	await this.$httpReports.post('documents/list-document-sale-pdf', documentData);
	const hrefTag = '<a href="/documents" style="color:white; text-decoration:underline; font-weight:bold;">Documentos</a>';
	const msg = `El reporte de ventas está siendo generado, puede revisar su estado en la sección de ${hrefTag}`;
	this.showNotification(msg, 'green', 20000);
}

function onToggleSnackBar() {
	this.$bus.$on(TOGGLE_SNACKBAR, (snackbar) => {
		const newSnackbar = Object.assign({}, snackbar);
		newSnackbar.isVisible = true;
		this.snackbar = newSnackbar;
	});
}

function showExcelGenerateMessage() {
	const hrefTag = '<a href="/documents" style="color:white; text-decoration:underline; font-weight:bold;">Documentos</a>';
	const msg = `El excel está siendo generado, puede revisar su estado en la sección de ${hrefTag}`;
	this.showNotification(msg, 'green', 20000);
	this.loadingExcel = false;
}

function showGenericError(text = 'Ups, ocurrió algún problema', timeout = 5000) {
	this.showNotification(text, 'error', timeout);
}

function showRow(columns, columnId) {
	const column = columns.find(h => h.id === columnId);
	return column.visible;
}

function selectedRows(row, currentData, dataSelected, flag = false) {
	const prop = row.warWarehouseProductBrandId ? 'warWarehouseProductBrandId' : 'id';
	const products = currentData.map((product) => {
		const newProduct = { ...product };
		const propTwo = 'location';
		if (flag) {
			if (row[prop] === newProduct[prop] && row[propTwo] === newProduct[propTwo]) {
				newProduct.isSelected = row.isSelected;
			}
		} else if (row[prop] === newProduct[prop] && row.flagFree === newProduct.flagFree) {
			newProduct.isSelected = row.isSelected;
		}
		return newProduct;
	});
	let productsSelected = [...dataSelected];
	productsSelected = this.validationToAddRow(
		dataSelected,
		prop,
		row,
		productsSelected,
	);
	const checkAll = products.every(check => check.isSelected);
	return { products, productsSelected, checkAll };
}

function selecteAll(value, currentData, dataSelected) {
	let productsSelected = [...dataSelected];
	let products = [];
	const prop = 'id';
	if (currentData.length > 0) {
		products = currentData.map((dataSingle) => {
			const newData = { ...dataSingle };
			newData.isSelected = value;
			productsSelected = this.validationToAddRow(
				dataSelected,
				prop,
				newData,
				productsSelected,
			);
			return newData;
		});
	}
	return { products, productsSelected, checkAll: value };
}

function goBack() {
	this.$router.back();
}

async function onReportSaleCommissions(params) {
	const now = format(new Date(), 'YYYY_MM_DD_HH_mm_ss');
	const { name, lastname } = this.$userInfo;
	const documentData = {
		filename: `Reporte_Comisiones_de_ventas_pdf ${now}`,
		extension: 'pdf',
		comment: `Reporte_Comisiones_de_ventas_pdf generado por ${name} ${lastname}`,
		params,
	};
	await this.$httpReports.post('documents/list-commission-sale-pdf', documentData);
	const hrefTag = '<a href="/documents" style="color:white; text-decoration:underline; font-weight:bold;">Documentos</a>';
	const msg = `El reporte de ventas está siendo generado, puede revisar su estado en la sección de ${hrefTag}`;
	this.showNotification(msg, 'green', 20000);
}

function labelsByCountry() {
	const company = this.$userInfo.company;
	const country = company.country;
	const defaultCountry = {
		id: 1,
		name: 'Perú',
		currency: 'PEN',
		code: 'PER',
		coinValue: 'Soles',
		percentage: 18,
		taxName: 'IGV',
		taxAgency: 'Sunat',
		rucLength: 11,
		subsidiaryValue: 'ruc',
		idLabel: 'Tipo de Documento',
	};
	if (country) {
		return {
			id: country.id,
			code: country.countryCode,
			currency: company.currency,
			idLabel: country.countryCode === 'PER' ? 'Tipo de Documento' : 'Identificación',
			name: country.name,
			percentage: country.countryCode === 'PER' ? country.percentage || 18
				: country.percentage || 12,
			taxName: country.taxName,
			taxAgency: country.countryCode === 'PER' ? 'Sunat' : 'SRI',
			rucLength: country.countryCode === 'PER' ? 11 : 13,
			subsidiaryValue: country.countryCode === 'PER' ? 'ruc' : 'id',
		};
	}
	return defaultCountry;
}

function coinValue() {
	return this.isPeru ? 'Soles' : 'Dolares';
}

function countryCurrencySymbol() {
	return this.isPeru ? 'S/' : '$';
}

function isEcuador() {
	return this.labelsByCountry.id === 2;
}

function isPeru() {
	return this.labelsByCountry.id === 1;
}

async function loadTypePerson() {
	({ data: this.personTypes } = await this.$httpSales.get('type-person'));
}

function personType(value) {
	this.personValidations = value && value.configuration ? value.configuration.validations :
		value.configuration;
	if (this.personValidations) {
		this.maxDocument = this.personValidations.maxLength || 0;
		this.minDocument = this.personValidations.minLength || 0;
		if (this.maxDocument && this.minDocument) {
			if (this.maxDocument === this.minDocument) {
				this.documentMessage = `Es necesario ingresar ${this.minDocument} dígitos`;
			} else {
				this.documentMessage = `Es necesario ingresar entre ${this.minDocument} y ${this.maxDocument} dígitos`;
			}
		} else if (this.minDocument) {
			this.documentMessage = `Ingrese un mínimo de ${this.minDocument} dígitos`;
		} else if (this.maxDocument) {
			this.documentMessage = `Ingrese un máximo de ${this.maxDocument} dígitos`;
		} else {
			this.documentMessage = '';
		}
	} else {
		this.documentMessage = '';
	}
}

function openHelp({ code, actions }) {
	this.action.code = code;
	this.action.open = true;
	this.action.active = true;
	this.action.title = this.$route.meta.title;
	this.action.width = 500;
	this.actionsToHelp = [...actions];
}

function getCurrencies() {
	return this.$httpSales.get('currency');
}

function currencyByCountry(currencies) {
	return this.isEcuador ? currencies.filter(c => c.code === 'USD') : currencies;
}

function getCities() {
	return this.$httpSales.get('cities');
}

function stopClick() {
	return false;
}

function urlLoadData(method, code, params, id, model) {
	const url = id ? `group/${code}/table/${id}` : `group/${code}/table`;
	if (params && model) {
		return this.$httpSales[method](url, { params }, model);
	} else if (params) {
		return this.$httpSales[method](url, { params });
	} else if (model) {
		return this.$httpSales[method](url, model);
	}
	return this.$httpSales[method](url);
}

function currentWarehouseData() {
	const { codeTaxes: warehouseCodeTaxes, name: warehouseName } = this.$userInfo.warehouse;
	return { warehouseCodeTaxes, warehouseName };
}

function labelTerminal(plural = false) {
	if (plural) {
		return this.isPeru ? 'Puntos de Venta' : 'Terminales';
	}
	return this.isPeru ? 'Punto de Venta' : 'Terminal';
}

function labelSucursal(plural = false) {
	if (plural) {
		return this.isPeru ? 'Razones Sociales' : 'Sucursales';
	}
	return this.isPeru ? 'Razón Social' : 'Sucursal';
}

function labelWarehouse(plural = false) {
	if (plural) {
		return this.isPeru ? 'Almacén' : 'Tienda';
	}
	return this.isPeru ? 'Almacenes' : 'Tiendas';
}

function validationToAddRow(itemsSelected, itemProp, item, newItemsSelected) {
	if (item.isSelected) {
		if (itemsSelected.length > 0) {
			const dataToAdd = itemsSelected.find(rowSelected =>
				rowSelected[itemProp] === item[itemProp]);
			if (!dataToAdd) {
				newItemsSelected.push(item);
			}
		} else {
			newItemsSelected.push(item);
		}
	} else {
		const index = newItemsSelected.findIndex(rowData => rowData[itemProp]
			=== item[itemProp]);
		newItemsSelected.splice(index, 1);
	}
	return newItemsSelected;
}

const mixin = {
	data,
	computed: {
		coinValue,
		countryCurrencySymbol,
		isEcuador,
		isPeru,
		labelsByCountry,
		currentWarehouseData,
	},
	methods: {
		amountsCalculate,
		brandsList,
		calculateLimit,
		categoriesList,
		currencyByCountry,
		customersList,
		customerSelections,
		employeeSelections,
		getExchangeRate,
		exchangeByDate,
		expensesList,
		exportTable,
		getAccountType,
		getBanks,
		getBankAccount,
		getChecks,
		getCheckSeries,
		getCurrencies,
		getCities,
		getPaymentsMethods,
		getProductPrice,
		getTypeDocuments,
		getTypePayments,
		globalEmployees,
		goBack,
		goTo,
		listPricingPromise,
		listOfUnits,
		loadTypePerson,
		newAmountsCalculate,
		onAmortizationList,
		onPayableList,
		onEmitDocumentWithFormat,
		onEmitExcel,
		onProductList,
		onReportSale,
		onToggleSnackBar,
		openHelp,
		selecteAll,
		productsSelections,
		roundInNumber,
		selectedRows,
		setProductPrice,
		showExcelGenerateMessage,
		showGenericError,
		showNotification,
		showRow,
		stopClick,
		subsidiariesList,
		massiveUploadList,
		massiveUploadRollback,
		typeExpensesList,
		urlLoadData,
		warehousesList,
		labelTerminal,
		labelSucursal,
		labelWarehouse,
		onReportSaleCommissions,
		validationToAddRow,
	},
	watch: {
		personType,
	},
};

export default mixin;



// WEBPACK FOOTER //
// ./src/mixins/global.js